import { i18n } from "../translate/i18n";

export const chronologicalReadingOrderBibleArray = [
  {
    name: "genesis",
    bookAbbreviation: i18n.t("messages.bibleBooks.genesis.abbreviation"),
    startChapter: 1,
    endChapter: 11,
    chapters: 11,
    testment: i18n.t("messages.bibleBooks.genesis.testament"),
    id: "genesis-start-1",
  },
  {
    name: "job",
    bookAbbreviation: i18n.t("messages.bibleBooks.job.abbreviation"),
    startChapter: 1,
    endChapter: 42,
    chapters: 42,
    testment: i18n.t("messages.bibleBooks.job.testament"),
    id: "job-start-1",
  },
  {
    name: "genesis",
    bookAbbreviation: i18n.t("messages.bibleBooks.genesis.abbreviation"),
    startChapter: 12,
    endChapter: 50,
    chapters: 39,
    testment: i18n.t("messages.bibleBooks.genesis.testament"),
    id: "genesis-start-12",
  },
  {
    name: "exodus",
    bookAbbreviation: i18n.t("messages.bibleBooks.exodus.abbreviation"),
    startChapter: 1,
    endChapter: 40,
    chapters: 40,
    testment: i18n.t("messages.bibleBooks.exodus.testament"),
    id: "exodus-start-1",
  },
  {
    name: "leviticus",
    bookAbbreviation: i18n.t("messages.bibleBooks.leviticus.abbreviation"),
    startChapter: 1,
    endChapter: 27,
    chapters: 27,
    testment: i18n.t("messages.bibleBooks.leviticus.testament"),
    id: "leviticus-start-1",
  },
  {
    name: "numbers",
    bookAbbreviation: i18n.t("messages.bibleBooks.numbers.abbreviation"),
    startChapter: 1,
    endChapter: 36,
    chapters: 36,
    testment: i18n.t("messages.bibleBooks.numbers.testament"),
    id: "numbers-start-1",
  },
  {
    name: "deuteronomy",
    bookAbbreviation: i18n.t("messages.bibleBooks.deuteronomy.abbreviation"),
    startChapter: 1,
    endChapter: 34,
    chapters: 34,
    testment: i18n.t("messages.bibleBooks.deuteronomy.testament"),
    id: "deuteronomy-start-1",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 90,
    endChapter: 90,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-90",
  },
  {
    name: "joshua",
    bookAbbreviation: i18n.t("messages.bibleBooks.joshua.abbreviation"),
    startChapter: 1,
    endChapter: 24,
    chapters: 24,
    testment: i18n.t("messages.bibleBooks.joshua.testament"),
    id: "joshua-start-1",
  },
  {
    name: "judges",
    bookAbbreviation: i18n.t("messages.bibleBooks.judges.abbreviation"),
    startChapter: 1,
    endChapter: 21,
    chapters: 21,
    testment: i18n.t("messages.bibleBooks.judges.testament"),
    id: "judges-start-1",
  },
  {
    name: "ruth",
    bookAbbreviation: i18n.t("messages.bibleBooks.ruth.abbreviation"),
    startChapter: 1,
    endChapter: 4,
    chapters: 4,
    testment: i18n.t("messages.bibleBooks.ruth.testament"),
    id: "ruth-start-1",
  },
  {
    name: "samuel1",
    bookAbbreviation: i18n.t("messages.bibleBooks.samuel1.abbreviation"),
    startChapter: 1,
    endChapter: 20,
    chapters: 20,
    testment: i18n.t("messages.bibleBooks.samuel1.testament"),
    id: "samuel1-start-1",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 11,
    endChapter: 11,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-11",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 59,
    endChapter: 59,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-59",
  },
  {
    name: "samuel1",
    bookAbbreviation: i18n.t("messages.bibleBooks.samuel1.abbreviation"),
    startChapter: 21,
    endChapter: 24,
    chapters: 4,
    testment: i18n.t("messages.bibleBooks.samuel1.testament"),
    id: "samuel1-start-21",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 91,
    endChapter: 91,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-91",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 7,
    endChapter: 7,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-7",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 27,
    endChapter: 27,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-27",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 31,
    endChapter: 31,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-31",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 34,
    endChapter: 34,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-34",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 52,
    endChapter: 52,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-52",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 56,
    endChapter: 56,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-56",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 120,
    endChapter: 120,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-120",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 140,
    endChapter: 142,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-140",
  },
  {
    name: "samuel1",
    bookAbbreviation: i18n.t("messages.bibleBooks.samuel1.abbreviation"),
    startChapter: 25,
    endChapter: 27,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.samuel1.testament"),
    id: "samuel1-start-25",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 17,
    endChapter: 17,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-17",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 35,
    endChapter: 35,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-35",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 54,
    endChapter: 54,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-54",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 63,
    endChapter: 63,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-63",
  },
  {
    name: "samuel1",
    bookAbbreviation: i18n.t("messages.bibleBooks.samuel1.abbreviation"),
    startChapter: 28,
    endChapter: 31,
    chapters: 4,
    testment: i18n.t("messages.bibleBooks.samuel1.testament"),
    id: "samuel1-start-28",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 18,
    endChapter: 18,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-18",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 121,
    endChapter: 121,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-121",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 123,
    endChapter: 125,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-123",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 128,
    endChapter: 130,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-128",
  },
  {
    name: "samuel2",
    bookAbbreviation: i18n.t("messages.bibleBooks.samuel2.abbreviation"),
    startChapter: 1,
    endChapter: 4,
    chapters: 4,
    testment: i18n.t("messages.bibleBooks.samuel2.testament"),
    id: "samuel2-start-1",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 6,
    endChapter: 6,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-6",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 8,
    endChapter: 10,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-8",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 14,
    endChapter: 14,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-14",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 16,
    endChapter: 16,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-16",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 19,
    endChapter: 19,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-19",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 21,
    endChapter: 21,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-21",
  },
  {
    name: "chronicles1",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles1.abbreviation"),
    startChapter: 1,
    endChapter: 2,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.chronicles1.testament"),
    id: "chronicles1-start-1",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 43,
    endChapter: 45,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-43",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 49,
    endChapter: 49,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-49",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 84,
    endChapter: 85,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-84",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 87,
    endChapter: 87,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-87",
  },
  {
    name: "chronicles1",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles1.abbreviation"),
    startChapter: 3,
    endChapter: 5,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.chronicles1.testament"),
    id: "chronicles1-start-3",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 73,
    endChapter: 73,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-73",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 77,
    endChapter: 78,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-77",
  },
  {
    name: "chronicles1",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles1.abbreviation"),
    startChapter: 6,
    endChapter: 6,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.chronicles1.testament"),
    id: "chronicles1-start-6",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 81,
    endChapter: 81,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-81",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 88,
    endChapter: 88,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-88",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 92,
    endChapter: 93,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-92",
  },
  {
    name: "chronicles1",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles1.abbreviation"),
    startChapter: 7,
    endChapter: 10,
    chapters: 4,
    testment: i18n.t("messages.bibleBooks.chronicles1.testament"),
    id: "chronicles1-start-7",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 102,
    endChapter: 104,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-102",
  },
  {
    name: "samuel2",
    bookAbbreviation: i18n.t("messages.bibleBooks.samuel2.abbreviation"),
    startChapter: 5,
    endChapter: 5,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.samuel2.testament"),
    id: "samuel2-start-5",
  },
  {
    name: "chronicles1",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles1.abbreviation"),
    startChapter: 11,
    endChapter: 12,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.chronicles1.testament"),
    id: "chronicles1-start-11",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 133,
    endChapter: 133,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-133",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 106,
    endChapter: 107,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-106",
  },
  {
    name: "chronicles1",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles1.abbreviation"),
    startChapter: 13,
    endChapter: 16,
    chapters: 4,
    testment: i18n.t("messages.bibleBooks.chronicles1.testament"),
    id: "chronicles1-start-13",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 1,
    endChapter: 2,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-1",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 15,
    endChapter: 15,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-15",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 22,
    endChapter: 24,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-22",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 47,
    endChapter: 47,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-47",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 68,
    endChapter: 68,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-68",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 89,
    endChapter: 89,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-89",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 96,
    endChapter: 96,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-96",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 100,
    endChapter: 101,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-100",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 105,
    endChapter: 105,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-105",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 132,
    endChapter: 132,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-132",
  },
  {
    name: "samuel2",
    bookAbbreviation: i18n.t("messages.bibleBooks.samuel2.abbreviation"),
    startChapter: 6,
    endChapter: 7,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.samuel2.testament"),
    id: "samuel2-start-6",
  },
  {
    name: "chronicles1",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles1.abbreviation"),
    startChapter: 17,
    endChapter: 17,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.chronicles1.testament"),
    id: "chronicles1-start-17",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 25,
    endChapter: 25,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-25",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 29,
    endChapter: 29,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-29",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 33,
    endChapter: 33,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-33",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 36,
    endChapter: 36,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-36",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 39,
    endChapter: 39,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-39",
  },
  {
    name: "samuel2",
    bookAbbreviation: i18n.t("messages.bibleBooks.samuel2.abbreviation"),
    startChapter: 8,
    endChapter: 9,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.samuel2.testament"),
    id: "samuel2-start-8",
  },
  {
    name: "chronicles1",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles1.abbreviation"),
    startChapter: 18,
    endChapter: 18,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.chronicles1.testament"),
    id: "chronicles1-start-18",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 50,
    endChapter: 50,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-50",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 53,
    endChapter: 53,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-53",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 60,
    endChapter: 60,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-60",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 75,
    endChapter: 75,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-75",
  },
  {
    name: "samuel2",
    bookAbbreviation: i18n.t("messages.bibleBooks.samuel2.abbreviation"),
    startChapter: 10,
    endChapter: 10,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.samuel2.testament"),
    id: "samuel2-start-10",
  },
  {
    name: "chronicles1",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles1.abbreviation"),
    startChapter: 19,
    endChapter: 19,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.chronicles1.testament"),
    id: "chronicles1-start-19",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 20,
    endChapter: 20,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-20",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 65,
    endChapter: 67,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-65",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 69,
    endChapter: 70,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-69",
  },
  {
    name: "samuel2",
    bookAbbreviation: i18n.t("messages.bibleBooks.samuel2.abbreviation"),
    startChapter: 11,
    endChapter: 12,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.samuel2.testament"),
    id: "samuel2-start-11",
  },
  {
    name: "chronicles1",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles1.abbreviation"),
    startChapter: 20,
    endChapter: 20,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.chronicles1.testament"),
    id: "chronicles1-start-20",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 32,
    endChapter: 32,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-32",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 51,
    endChapter: 51,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-51",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 86,
    endChapter: 86,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-86",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 122,
    endChapter: 122,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-122",
  },
  {
    name: "samuel2",
    bookAbbreviation: i18n.t("messages.bibleBooks.samuel2.abbreviation"),
    startChapter: 13,
    endChapter: 15,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.samuel2.testament"),
    id: "samuel2-start-13",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 3,
    endChapter: 4,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-3",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 12,
    endChapter: 13,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-12",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 28,
    endChapter: 28,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-28",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 55,
    endChapter: 55,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-55",
  },
  {
    name: "samuel2",
    bookAbbreviation: i18n.t("messages.bibleBooks.samuel2.abbreviation"),
    startChapter: 16,
    endChapter: 18,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.samuel2.testament"),
    id: "samuel2-start-16",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 26,
    endChapter: 26,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-26",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 40,
    endChapter: 40,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-40",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 58,
    endChapter: 58,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-58",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 61,
    endChapter: 62,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-61",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 64,
    endChapter: 64,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-64",
  },
  {
    name: "samuel2",
    bookAbbreviation: i18n.t("messages.bibleBooks.samuel2.abbreviation"),
    startChapter: 19,
    endChapter: 21,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.samuel2.testament"),
    id: "samuel2-start-19",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 5,
    endChapter: 5,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-5",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 38,
    endChapter: 38,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-38",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 41,
    endChapter: 42,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-41",
  },
  {
    name: "samuel2",
    bookAbbreviation: i18n.t("messages.bibleBooks.samuel2.abbreviation"),
    startChapter: 22,
    endChapter: 23,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.samuel2.testament"),
    id: "samuel2-start-22",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 57,
    endChapter: 57,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-57",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 95,
    endChapter: 95,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-95",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 97,
    endChapter: 99,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-97",
  },
  {
    name: "samuel2",
    bookAbbreviation: i18n.t("messages.bibleBooks.samuel2.abbreviation"),
    startChapter: 24,
    endChapter: 24,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.samuel2.testament"),
    id: "samuel2-start-24",
  },
  {
    name: "chronicles1",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles1.abbreviation"),
    startChapter: 21,
    endChapter: 22,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.chronicles1.testament"),
    id: "chronicles1-start-21",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 30,
    endChapter: 30,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-30",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 108,
    endChapter: 110,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-108",
  },
  {
    name: "chronicles1",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles1.abbreviation"),
    startChapter: 23,
    endChapter: 25,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.chronicles1.testament"),
    id: "chronicles1-start-23",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 131,
    endChapter: 131,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-131",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 138,
    endChapter: 139,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-138",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 143,
    endChapter: 145,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-143",
  },
  {
    name: "chronicles1",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles1.abbreviation"),
    startChapter: 26,
    endChapter: 29,
    chapters: 4,
    testment: i18n.t("messages.bibleBooks.chronicles1.testament"),
    id: "chronicles1-start-26",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 127,
    endChapter: 127,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-127",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 111,
    endChapter: 118,
    chapters: 8,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-111",
  },
  {
    name: "kings1",
    bookAbbreviation: i18n.t("messages.bibleBooks.kings1.abbreviation"),
    startChapter: 1,
    endChapter: 2,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.kings1.testament"),
    id: "1kings-start-1",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 37,
    endChapter: 37,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-37",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 71,
    endChapter: 71,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-71",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 94,
    endChapter: 94,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-94",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 119,
    endChapter: 119,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-119",
  },
  {
    name: "kings1",
    bookAbbreviation: i18n.t("messages.bibleBooks.kings1.abbreviation"),
    startChapter: 3,
    endChapter: 4,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.kings1.testament"),
    id: "1kings-start-3",
  },
  {
    name: "chronicles2",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles2.abbreviation"),
    startChapter: 1,
    endChapter: 1,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.chronicles2.testament"),
    id: "2chronicles-start-1",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 72,
    endChapter: 72,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-72",
  },
  {
    name: "solomonsongof",
    bookAbbreviation: i18n.t("messages.bibleBooks.solomonsongof.abbreviation"),
    startChapter: 1,
    endChapter: 8,
    chapters: 8,
    testment: i18n.t("messages.bibleBooks.solomonsongof.testament"),
    id: "solomonsongof-start-1",
  },
  {
    name: "proverbs",
    bookAbbreviation: i18n.t("messages.bibleBooks.proverbs.abbreviation"),
    startChapter: 1,
    endChapter: 24,
    chapters: 24,
    testment: i18n.t("messages.bibleBooks.proverbs.testament"),
    id: "proverbs-start-1",
  },
  {
    name: "kings1",
    bookAbbreviation: i18n.t("messages.bibleBooks.kings1.abbreviation"),
    startChapter: 5,
    endChapter: 6,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.kings1.testament"),
    id: "1kings-start-5",
  },
  {
    name: "chronicles2",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles2.abbreviation"),
    startChapter: 2,
    endChapter: 3,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.chronicles2.testament"),
    id: "2chronicles-start-2",
  },
  {
    name: "kings1",
    bookAbbreviation: i18n.t("messages.bibleBooks.kings1.abbreviation"),
    startChapter: 7,
    endChapter: 7,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.kings1.testament"),
    id: "1kings-start-7",
  },
  {
    name: "chronicles2",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles2.abbreviation"),
    startChapter: 4,
    endChapter: 4,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.chronicles2.testament"),
    id: "2chronicles-start-4",
  },
  {
    name: "kings1",
    bookAbbreviation: i18n.t("messages.bibleBooks.kings1.abbreviation"),
    startChapter: 8,
    endChapter: 8,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.kings1.testament"),
    id: "1kings-start-8",
  },
  {
    name: "chronicles2",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles2.abbreviation"),
    startChapter: 5,
    endChapter: 7,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.chronicles2.testament"),
    id: "2chronicles-start-5",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 136,
    endChapter: 136,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-136",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 134,
    endChapter: 134,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-134",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 146,
    endChapter: 150,
    chapters: 5,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-146",
  },
  {
    name: "kings1",
    bookAbbreviation: i18n.t("messages.bibleBooks.kings1.abbreviation"),
    startChapter: 9,
    endChapter: 9,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.kings1.testament"),
    id: "1kings-start-9",
  },
  {
    name: "chronicles2",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles2.abbreviation"),
    startChapter: 8,
    endChapter: 8,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.chronicles2.testament"),
    id: "2chronicles-start-8",
  },
  {
    name: "proverbs",
    bookAbbreviation: i18n.t("messages.bibleBooks.proverbs.abbreviation"),
    startChapter: 25,
    endChapter: 29,
    chapters: 5,
    testment: i18n.t("messages.bibleBooks.proverbs.testament"),
    id: "proverbs-start-25",
  },
  {
    name: "ecclesiastes",
    bookAbbreviation: i18n.t("messages.bibleBooks.ecclesiastes.abbreviation"),
    startChapter: 1,
    endChapter: 12,
    chapters: 12,
    testment: i18n.t("messages.bibleBooks.ecclesiastes.testament"),
    id: "ecclesiastes-start-1",
  },
  {
    name: "kings1",
    bookAbbreviation: i18n.t("messages.bibleBooks.kings1.abbreviation"),
    startChapter: 10,
    endChapter: 11,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.kings1.testament"),
    id: "1kings-start-10",
  },
  {
    name: "chronicles2",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles2.abbreviation"),
    startChapter: 9,
    endChapter: 9,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.chronicles2.testament"),
    id: "2chronicles-start-9",
  },
  {
    name: "proverbs",
    bookAbbreviation: i18n.t("messages.bibleBooks.proverbs.abbreviation"),
    startChapter: 30,
    endChapter: 31,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.proverbs.testament"),
    id: "proverbs-start-30",
  },
  {
    name: "kings1",
    bookAbbreviation: i18n.t("messages.bibleBooks.kings1.abbreviation"),
    startChapter: 12,
    endChapter: 14,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.kings1.testament"),
    id: "1kings-start-12",
  },
  {
    name: "chronicles2",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles2.abbreviation"),
    startChapter: 10,
    endChapter: 12,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.chronicles2.testament"),
    id: "2chronicles-start-10",
  },
  {
    name: "kings1",
    bookAbbreviation: i18n.t("messages.bibleBooks.kings1.abbreviation"),
    startChapter: 15,
    endChapter: 15,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.kings1.testament"),
    id: "1kings-start-15",
  },
  {
    name: "chronicles2",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles2.abbreviation"),
    startChapter: 13,
    endChapter: 16,
    chapters: 4,
    testment: i18n.t("messages.bibleBooks.chronicles2.testament"),
    id: "2chronicles-start-13",
  },
  {
    name: "kings1",
    bookAbbreviation: i18n.t("messages.bibleBooks.kings1.abbreviation"),
    startChapter: 16,
    endChapter: 16,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.kings1.testament"),
    id: "1kings-start-16",
  },
  {
    name: "chronicles2",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles2.abbreviation"),
    startChapter: 17,
    endChapter: 17,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.chronicles2.testament"),
    id: "2chronicles-start-17",
  },
  {
    name: "kings1",
    bookAbbreviation: i18n.t("messages.bibleBooks.kings1.abbreviation"),
    startChapter: 17,
    endChapter: 22,
    chapters: 6,
    testment: i18n.t("messages.bibleBooks.kings1.testament"),
    id: "1kings-start-17",
  },
  {
    name: "chronicles2",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles2.abbreviation"),
    startChapter: 18,
    endChapter: 23,
    chapters: 6,
    testment: i18n.t("messages.bibleBooks.chronicles2.testament"),
    id: "2chronicles-start-18",
  },
  {
    name: "obadiah",
    bookAbbreviation: i18n.t("messages.bibleBooks.obadiah.abbreviation"),
    startChapter: 1,
    endChapter: 1,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.obadiah.testament"),
    id: "obadiah-start-1",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 82,
    endChapter: 83,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-82",
  },
  {
    name: "kings2",
    bookAbbreviation: i18n.t("messages.bibleBooks.kings2.abbreviation"),
    startChapter: 1,
    endChapter: 13,
    chapters: 13,
    testment: i18n.t("messages.bibleBooks.kings2.testament"),
    id: "2kings-start-1",
  },
  {
    name: "chronicles2",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles2.abbreviation"),
    startChapter: 24,
    endChapter: 24,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.chronicles2.testament"),
    id: "2chronicles-start-24",
  },
  {
    name: "kings2",
    bookAbbreviation: i18n.t("messages.bibleBooks.kings2.abbreviation"),
    startChapter: 14,
    endChapter: 14,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.kings2.testament"),
    id: "2kings-start-14",
  },
  {
    name: "chronicles2",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles2.abbreviation"),
    startChapter: 25,
    endChapter: 25,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.chronicles2.testament"),
    id: "2chronicles-start-25",
  },
  {
    name: "jonah",
    bookAbbreviation: i18n.t("messages.bibleBooks.jonah.abbreviation"),
    startChapter: 1,
    endChapter: 4,
    chapters: 4,
    testment: i18n.t("messages.bibleBooks.jonah.testament"),
    id: "jonah-start-1",
  },
  {
    name: "kings2",
    bookAbbreviation: i18n.t("messages.bibleBooks.kings2.abbreviation"),
    startChapter: 15,
    endChapter: 15,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.kings2.testament"),
    id: "2kings-start-15",
  },
  {
    name: "chronicles2",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles2.abbreviation"),
    startChapter: 26,
    endChapter: 26,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.chronicles2.testament"),
    id: "2chronicles-start-26",
  },
  {
    name: "isaiah",
    bookAbbreviation: i18n.t("messages.bibleBooks.isaiah.abbreviation"),
    startChapter: 1,
    endChapter: 8,
    chapters: 8,
    testment: i18n.t("messages.bibleBooks.isaiah.testament"),
    id: "isaiah-start-1",
  },
  {
    name: "amos",
    bookAbbreviation: i18n.t("messages.bibleBooks.amos.abbreviation"),
    startChapter: 1,
    endChapter: 9,
    chapters: 9,
    testment: i18n.t("messages.bibleBooks.amos.testament"),
    id: "amos-start-1",
  },
  {
    name: "chronicles2",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles2.abbreviation"),
    startChapter: 27,
    endChapter: 27,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.chronicles2.testament"),
    id: "2chronicles-start-27",
  },
  {
    name: "isaiah",
    bookAbbreviation: i18n.t("messages.bibleBooks.isaiah.abbreviation"),
    startChapter: 9,
    endChapter: 12,
    chapters: 4,
    testment: i18n.t("messages.bibleBooks.isaiah.testament"),
    id: "isaiah-start-9",
  },
  {
    name: "micah",
    bookAbbreviation: i18n.t("messages.bibleBooks.micah.abbreviation"),
    startChapter: 1,
    endChapter: 7,
    chapters: 7,
    testment: i18n.t("messages.bibleBooks.micah.testament"),
    id: "micah-start-1",
  },
  {
    name: "chronicles2",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles2.abbreviation"),
    startChapter: 28,
    endChapter: 28,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.chronicles2.testament"),
    id: "2chronicles-start-28",
  },
  {
    name: "kings2",
    bookAbbreviation: i18n.t("messages.bibleBooks.kings2.abbreviation"),
    startChapter: 16,
    endChapter: 17,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.kings2.testament"),
    id: "2kings-start-16",
  },
  {
    name: "isaiah",
    bookAbbreviation: i18n.t("messages.bibleBooks.isaiah.abbreviation"),
    startChapter: 13,
    endChapter: 27,
    chapters: 15,
    testment: i18n.t("messages.bibleBooks.isaiah.testament"),
    id: "isaiah-start-13",
  },
  {
    name: "kings2",
    bookAbbreviation: i18n.t("messages.bibleBooks.kings2.abbreviation"),
    startChapter: 18,
    endChapter: 18,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.kings2.testament"),
    id: "2kings-start-18",
  },
  {
    name: "chronicles2",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles2.abbreviation"),
    startChapter: 29,
    endChapter: 31,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.chronicles2.testament"),
    id: "2chronicles-start-29",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 48,
    endChapter: 48,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-48",
  },
  {
    name: "hosea",
    bookAbbreviation: i18n.t("messages.bibleBooks.hosea.abbreviation"),
    startChapter: 1,
    endChapter: 14,
    chapters: 14,
    testment: i18n.t("messages.bibleBooks.hosea.testament"),
    id: "hosea-start-1",
  },
  {
    name: "isaiah",
    bookAbbreviation: i18n.t("messages.bibleBooks.isaiah.abbreviation"),
    startChapter: 28,
    endChapter: 39,
    chapters: 12,
    testment: i18n.t("messages.bibleBooks.isaiah.testament"),
    id: "isaiah-start-28",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 76,
    endChapter: 76,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-76",
  },
  {
    name: "isaiah",
    bookAbbreviation: i18n.t("messages.bibleBooks.isaiah.abbreviation"),
    startChapter: 40,
    endChapter: 48,
    chapters: 9,
    testment: i18n.t("messages.bibleBooks.isaiah.testament"),
    id: "isaiah-start-40",
  },
  {
    name: "kings2",
    bookAbbreviation: i18n.t("messages.bibleBooks.kings2.abbreviation"),
    startChapter: 19,
    endChapter: 19,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.kings2.testament"),
    id: "2kings-start-19",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 46,
    endChapter: 46,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-46",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 80,
    endChapter: 80,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-80",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 135,
    endChapter: 135,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-135",
  },
  {
    name: "isaiah",
    bookAbbreviation: i18n.t("messages.bibleBooks.isaiah.abbreviation"),
    startChapter: 49,
    endChapter: 66,
    chapters: 18,
    testment: i18n.t("messages.bibleBooks.isaiah.testament"),
    id: "isaiah-start-49",
  },
  {
    name: "kings2",
    bookAbbreviation: i18n.t("messages.bibleBooks.kings2.abbreviation"),
    startChapter: 20,
    endChapter: 21,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.kings2.testament"),
    id: "2kings-start-20",
  },
  {
    name: "chronicles2",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles2.abbreviation"),
    startChapter: 32,
    endChapter: 33,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.chronicles2.testament"),
    id: "2chronicles-start-32",
  },
  {
    name: "nahum",
    bookAbbreviation: i18n.t("messages.bibleBooks.nahum.abbreviation"),
    startChapter: 1,
    endChapter: 3,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.nahum.testament"),
    id: "nahum-start-1",
  },
  {
    name: "kings2",
    bookAbbreviation: i18n.t("messages.bibleBooks.kings2.abbreviation"),
    startChapter: 22,
    endChapter: 23,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.kings2.testament"),
    id: "2kings-start-22",
  },
  {
    name: "chronicles2",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles2.abbreviation"),
    startChapter: 34,
    endChapter: 35,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.chronicles2.testament"),
    id: "2chronicles-start-34",
  },
  {
    name: "zephaniah",
    bookAbbreviation: i18n.t("messages.bibleBooks.zephaniah.abbreviation"),
    startChapter: 1,
    endChapter: 3,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.zephaniah.testament"),
    id: "zephaniah-start-1",
  },
  {
    name: "jeremiah",
    bookAbbreviation: i18n.t("messages.bibleBooks.jeremiah.abbreviation"),
    startChapter: 1,
    endChapter: 40,
    chapters: 40,
    testment: i18n.t("messages.bibleBooks.jeremiah.testament"),
    id: "jeremiah-start-1",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 74,
    endChapter: 74,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-74",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 79,
    endChapter: 79,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-79",
  },
  {
    name: "kings2",
    bookAbbreviation: i18n.t("messages.bibleBooks.kings2.abbreviation"),
    startChapter: 24,
    endChapter: 25,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.kings2.testament"),
    id: "2kings-start-24",
  },
  {
    name: "chronicles2",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles2.abbreviation"),
    startChapter: 36,
    endChapter: 36,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.chronicles2.testament"),
    id: "2chronicles-start-36",
  },
  {
    name: "habakkuk",
    bookAbbreviation: i18n.t("messages.bibleBooks.habakkuk.abbreviation"),
    startChapter: 1,
    endChapter: 3,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.habakkuk.testament"),
    id: "habakkuk-start-1",
  },
  {
    name: "jeremiah",
    bookAbbreviation: i18n.t("messages.bibleBooks.jeremiah.abbreviation"),
    startChapter: 41,
    endChapter: 52,
    chapters: 12,
    testment: i18n.t("messages.bibleBooks.jeremiah.testament"),
    id: "jeremiah-start-41",
  },
  {
    name: "lamentations",
    bookAbbreviation: i18n.t("messages.bibleBooks.lamentations.abbreviation"),
    startChapter: 1,
    endChapter: 5,
    chapters: 5,
    testment: i18n.t("messages.bibleBooks.lamentations.testament"),
    id: "lamentations-start-1",
  },
  {
    name: "ezekiel",
    bookAbbreviation: i18n.t("messages.bibleBooks.ezekiel.abbreviation"),
    startChapter: 1,
    endChapter: 48,
    chapters: 48,
    testment: i18n.t("messages.bibleBooks.ezekiel.testament"),
    id: "ezekiel-start-1",
  },
  {
    name: "joel",
    bookAbbreviation: i18n.t("messages.bibleBooks.joel.abbreviation"),
    startChapter: 1,
    endChapter: 3,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.joel.testament"),
    id: "joel-start-1",
  },
  {
    name: "daniel",
    bookAbbreviation: i18n.t("messages.bibleBooks.daniel.abbreviation"),
    startChapter: 1,
    endChapter: 12,
    chapters: 12,
    testment: i18n.t("messages.bibleBooks.daniel.testament"),
    id: "daniel-start-1",
  },
  {
    name: "ezra",
    bookAbbreviation: i18n.t("messages.bibleBooks.ezra.abbreviation"),
    startChapter: 1,
    endChapter: 6,
    chapters: 6,
    testment: i18n.t("messages.bibleBooks.ezra.testament"),
    id: "ezra-start-1",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 137,
    endChapter: 137,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-137",
  },
  {
    name: "haggai",
    bookAbbreviation: i18n.t("messages.bibleBooks.haggai.abbreviation"),
    startChapter: 1,
    endChapter: 2,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.haggai.testament"),
    id: "haggai-start-1",
  },
  {
    name: "zechariah",
    bookAbbreviation: i18n.t("messages.bibleBooks.zechariah.abbreviation"),
    startChapter: 1,
    endChapter: 14,
    chapters: 14,
    testment: i18n.t("messages.bibleBooks.zechariah.testament"),
    id: "zechariah-start-1",
  },
  {
    name: "esther",
    bookAbbreviation: i18n.t("messages.bibleBooks.esther.abbreviation"),
    startChapter: 1,
    endChapter: 10,
    chapters: 10,
    testment: i18n.t("messages.bibleBooks.esther.testament"),
    id: "esther-start-1",
  },
  {
    name: "ezra",
    bookAbbreviation: i18n.t("messages.bibleBooks.ezra.abbreviation"),
    startChapter: 7,
    endChapter: 10,
    chapters: 4,
    testment: i18n.t("messages.bibleBooks.ezra.testament"),
    id: "ezra-start-7",
  },
  {
    name: "nehemiah",
    bookAbbreviation: i18n.t("messages.bibleBooks.nehemiah.abbreviation"),
    startChapter: 1,
    endChapter: 13,
    chapters: 13,
    testment: i18n.t("messages.bibleBooks.nehemiah.testament"),
    id: "nehemiah-start-1",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 126,
    endChapter: 126,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms-start-126",
  },
  {
    name: "malachi",
    bookAbbreviation: i18n.t("messages.bibleBooks.malachi.abbreviation"),
    startChapter: 1,
    endChapter: 4,
    chapters: 4,
    testment: i18n.t("messages.bibleBooks.malachi.testament"),
    id: "malachi-start-1",
  },
  {
    name: "luke",
    bookAbbreviation: i18n.t("messages.bibleBooks.luke.abbreviation"),
    startChapter: 1,
    endChapter: 1,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.luke.testament"),
    id: "luke-start-1",
  },
  {
    name: "john",
    bookAbbreviation: i18n.t("messages.bibleBooks.john.abbreviation"),
    startChapter: 1,
    endChapter: 1,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.john.testament"),
    id: "john-start-1",
  },
  {
    name: "matthew",
    bookAbbreviation: i18n.t("messages.bibleBooks.matthew.abbreviation"),
    startChapter: 1,
    endChapter: 1,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.matthew.testament"),
    id: "matthew-start-1",
  },
  {
    name: "luke",
    bookAbbreviation: i18n.t("messages.bibleBooks.luke.abbreviation"),
    startChapter: 2,
    endChapter: 2,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.luke.testament"),
    id: "luke-start-2",
  },
  {
    name: "matthew",
    bookAbbreviation: i18n.t("messages.bibleBooks.matthew.abbreviation"),
    startChapter: 2,
    endChapter: 3,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.matthew.testament"),
    id: "matthew-start-2",
  },
  {
    name: "mark",
    bookAbbreviation: i18n.t("messages.bibleBooks.mark.abbreviation"),
    startChapter: 1,
    endChapter: 1,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.mark.testament"),
    id: "mark-start-1",
  },
  {
    name: "luke",
    bookAbbreviation: i18n.t("messages.bibleBooks.luke.abbreviation"),
    startChapter: 3,
    endChapter: 3,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.luke.testament"),
    id: "luke-start-3",
  },
  {
    name: "matthew",
    bookAbbreviation: i18n.t("messages.bibleBooks.matthew.abbreviation"),
    startChapter: 4,
    endChapter: 4,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.matthew.testament"),
    id: "matthew-start-4",
  },
  {
    name: "luke",
    bookAbbreviation: i18n.t("messages.bibleBooks.luke.abbreviation"),
    startChapter: 4,
    endChapter: 5,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.luke.testament"),
    id: "luke-start-4",
  },
  {
    name: "john",
    bookAbbreviation: i18n.t("messages.bibleBooks.john.abbreviation"),
    startChapter: 2,
    endChapter: 4,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.john.testament"),
    id: "john-start-2",
  },
  {
    name: "matthew",
    bookAbbreviation: i18n.t("messages.bibleBooks.matthew.abbreviation"),
    startChapter: 8,
    endChapter: 8,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.matthew.testament"),
    id: "matthew-start-8",
  },
  {
    name: "mark",
    bookAbbreviation: i18n.t("messages.bibleBooks.mark.abbreviation"),
    startChapter: 2,
    endChapter: 2,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.mark.testament"),
    id: "mark-start-2",
  },
  {
    name: "john",
    bookAbbreviation: i18n.t("messages.bibleBooks.john.abbreviation"),
    startChapter: 5,
    endChapter: 5,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.john.testament"),
    id: "john-start-5",
  },
  {
    name: "matthew",
    bookAbbreviation: i18n.t("messages.bibleBooks.matthew.abbreviation"),
    startChapter: 12,
    endChapter: 12,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.matthew.testament"),
    id: "matthew-start-12",
  },
  {
    name: "mark",
    bookAbbreviation: i18n.t("messages.bibleBooks.mark.abbreviation"),
    startChapter: 3,
    endChapter: 3,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.mark.testament"),
    id: "mark-start-3",
  },
  {
    name: "luke",
    bookAbbreviation: i18n.t("messages.bibleBooks.luke.abbreviation"),
    startChapter: 6,
    endChapter: 6,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.luke.testament"),
    id: "luke-start-6",
  },
  {
    name: "matthew",
    bookAbbreviation: i18n.t("messages.bibleBooks.matthew.abbreviation"),
    startChapter: 5,
    endChapter: 7,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.matthew.testament"),
    id: "matthew-start-5",
  },
  {
    name: "matthew",
    bookAbbreviation: i18n.t("messages.bibleBooks.matthew.abbreviation"),
    startChapter: 9,
    endChapter: 9,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.matthew.testament"),
    id: "matthew-start-9",
  },
  {
    name: "luke",
    bookAbbreviation: i18n.t("messages.bibleBooks.luke.abbreviation"),
    startChapter: 7,
    endChapter: 7,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.luke.testament"),
    id: "luke-start-7",
  },
  {
    name: "matthew",
    bookAbbreviation: i18n.t("messages.bibleBooks.matthew.abbreviation"),
    startChapter: 11,
    endChapter: 11,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.matthew.testament"),
    id: "matthew-start-11",
  },
  {
    name: "luke",
    bookAbbreviation: i18n.t("messages.bibleBooks.luke.abbreviation"),
    startChapter: 11,
    endChapter: 11,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.luke.testament"),
    id: "luke-start-11",
  },
  {
    name: "matthew",
    bookAbbreviation: i18n.t("messages.bibleBooks.matthew.abbreviation"),
    startChapter: 13,
    endChapter: 13,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.matthew.testament"),
    id: "matthew-start-13",
  },
  {
    name: "luke",
    bookAbbreviation: i18n.t("messages.bibleBooks.luke.abbreviation"),
    startChapter: 8,
    endChapter: 8,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.luke.testament"),
    id: "luke-start-8",
  },
  {
    name: "mark",
    bookAbbreviation: i18n.t("messages.bibleBooks.mark.abbreviation"),
    startChapter: 4,
    endChapter: 5,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.mark.testament"),
    id: "mark-start-4",
  },
  {
    name: "matthew",
    bookAbbreviation: i18n.t("messages.bibleBooks.matthew.abbreviation"),
    startChapter: 10,
    endChapter: 10,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.matthew.testament"),
    id: "matthew-start-10",
  },
  {
    name: "matthew",
    bookAbbreviation: i18n.t("messages.bibleBooks.matthew.abbreviation"),
    startChapter: 14,
    endChapter: 14,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.matthew.testament"),
    id: "matthew-start-14",
  },
  {
    name: "mark",
    bookAbbreviation: i18n.t("messages.bibleBooks.mark.abbreviation"),
    startChapter: 6,
    endChapter: 6,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.mark.testament"),
    id: "mark-start-6",
  },
  {
    name: "luke",
    bookAbbreviation: i18n.t("messages.bibleBooks.luke.abbreviation"),
    startChapter: 9,
    endChapter: 9,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.luke.testament"),
    id: "luke-start-9",
  },
  {
    name: "john",
    bookAbbreviation: i18n.t("messages.bibleBooks.john.abbreviation"),
    startChapter: 6,
    endChapter: 6,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.john.testament"),
    id: "john-start-6",
  },
  {
    name: "matthew",
    bookAbbreviation: i18n.t("messages.bibleBooks.matthew.abbreviation"),
    startChapter: 15,
    endChapter: 15,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.matthew.testament"),
    id: "matthew-start-15",
  },
  {
    name: "mark",
    bookAbbreviation: i18n.t("messages.bibleBooks.mark.abbreviation"),
    startChapter: 7,
    endChapter: 7,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.mark.testament"),
    id: "mark-start-7",
  },
  {
    name: "matthew",
    bookAbbreviation: i18n.t("messages.bibleBooks.matthew.abbreviation"),
    startChapter: 16,
    endChapter: 16,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.matthew.testament"),
    id: "matthew-start-16",
  },
  {
    name: "mark",
    bookAbbreviation: i18n.t("messages.bibleBooks.mark.abbreviation"),
    startChapter: 8,
    endChapter: 8,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.mark.testament"),
    id: "mark-start-8",
  },
  {
    name: "matthew",
    bookAbbreviation: i18n.t("messages.bibleBooks.matthew.abbreviation"),
    startChapter: 17,
    endChapter: 17,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.matthew.testament"),
    id: "matthew-start-17",
  },
  {
    name: "mark",
    bookAbbreviation: i18n.t("messages.bibleBooks.mark.abbreviation"),
    startChapter: 9,
    endChapter: 9,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.mark.testament"),
    id: "mark-start-9",
  },
  {
    name: "matthew",
    bookAbbreviation: i18n.t("messages.bibleBooks.matthew.abbreviation"),
    startChapter: 18,
    endChapter: 18,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.matthew.testament"),
    id: "matthew-start-18",
  },
  {
    name: "john",
    bookAbbreviation: i18n.t("messages.bibleBooks.john.abbreviation"),
    startChapter: 7,
    endChapter: 10,
    chapters: 4,
    testment: i18n.t("messages.bibleBooks.john.testament"),
    id: "john-start-7",
  },
  {
    name: "luke",
    bookAbbreviation: i18n.t("messages.bibleBooks.luke.abbreviation"),
    startChapter: 10,
    endChapter: 10,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.luke.testament"),
    id: "luke-start-10",
  },
  {
    name: "luke",
    bookAbbreviation: i18n.t("messages.bibleBooks.luke.abbreviation"),
    startChapter: 12,
    endChapter: 17,
    chapters: 6,
    testment: i18n.t("messages.bibleBooks.luke.testament"),
    id: "luke-start-12",
  },
  {
    name: "john",
    bookAbbreviation: i18n.t("messages.bibleBooks.john.abbreviation"),
    startChapter: 11,
    endChapter: 11,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.john.testament"),
    id: "john-start-11",
  },
  {
    name: "luke",
    bookAbbreviation: i18n.t("messages.bibleBooks.luke.abbreviation"),
    startChapter: 18,
    endChapter: 18,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.luke.testament"),
    id: "luke-start-18",
  },
  {
    name: "matthew",
    bookAbbreviation: i18n.t("messages.bibleBooks.matthew.abbreviation"),
    startChapter: 19,
    endChapter: 19,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.matthew.testament"),
    id: "matthew-start-19",
  },
  {
    name: "mark",
    bookAbbreviation: i18n.t("messages.bibleBooks.mark.abbreviation"),
    startChapter: 10,
    endChapter: 10,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.mark.testament"),
    id: "mark-start-10",
  },
  {
    name: "matthew",
    bookAbbreviation: i18n.t("messages.bibleBooks.matthew.abbreviation"),
    startChapter: 20,
    endChapter: 21,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.matthew.testament"),
    id: "matthew-start-20",
  },
  {
    name: "luke",
    bookAbbreviation: i18n.t("messages.bibleBooks.luke.abbreviation"),
    startChapter: 19,
    endChapter: 19,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.luke.testament"),
    id: "luke-start-19",
  },
  {
    name: "mark",
    bookAbbreviation: i18n.t("messages.bibleBooks.mark.abbreviation"),
    startChapter: 11,
    endChapter: 11,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.mark.testament"),
    id: "mark-start-11",
  },
  {
    name: "john",
    bookAbbreviation: i18n.t("messages.bibleBooks.john.abbreviation"),
    startChapter: 12,
    endChapter: 12,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.john.testament"),
    id: "john-start-12",
  },
  {
    name: "matthew",
    bookAbbreviation: i18n.t("messages.bibleBooks.matthew.abbreviation"),
    startChapter: 22,
    endChapter: 22,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.matthew.testament"),
    id: "matthew-start-22",
  },
  {
    name: "mark",
    bookAbbreviation: i18n.t("messages.bibleBooks.mark.abbreviation"),
    startChapter: 12,
    endChapter: 12,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.mark.testament"),
    id: "mark-start-12",
  },
  {
    name: "matthew",
    bookAbbreviation: i18n.t("messages.bibleBooks.matthew.abbreviation"),
    startChapter: 23,
    endChapter: 23,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.matthew.testament"),
    id: "matthew-start-23",
  },
  {
    name: "luke",
    bookAbbreviation: i18n.t("messages.bibleBooks.luke.abbreviation"),
    startChapter: 20,
    endChapter: 21,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.luke.testament"),
    id: "luke-start-20",
  },
  {
    name: "mark",
    bookAbbreviation: i18n.t("messages.bibleBooks.mark.abbreviation"),
    startChapter: 13,
    endChapter: 13,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.mark.testament"),
    id: "mark-start-13",
  },
  {
    name: "matthew",
    bookAbbreviation: i18n.t("messages.bibleBooks.matthew.abbreviation"),
    startChapter: 24,
    endChapter: 26,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.matthew.testament"),
    id: "matthew-start-24",
  },
  {
    name: "mark",
    bookAbbreviation: i18n.t("messages.bibleBooks.mark.abbreviation"),
    startChapter: 14,
    endChapter: 14,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.mark.testament"),
    id: "mark-start-14",
  },
  {
    name: "luke",
    bookAbbreviation: i18n.t("messages.bibleBooks.luke.abbreviation"),
    startChapter: 22,
    endChapter: 22,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.luke.testament"),
    id: "luke-start-22",
  },
  {
    name: "john",
    bookAbbreviation: i18n.t("messages.bibleBooks.john.abbreviation"),
    startChapter: 13,
    endChapter: 17,
    chapters: 5,
    testment: i18n.t("messages.bibleBooks.john.testament"),
    id: "john-start-13",
  },
  {
    name: "matthew",
    bookAbbreviation: i18n.t("messages.bibleBooks.matthew.abbreviation"),
    startChapter: 27,
    endChapter: 27,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.matthew.testament"),
    id: "matthew-start-27",
  },
  {
    name: "mark",
    bookAbbreviation: i18n.t("messages.bibleBooks.mark.abbreviation"),
    startChapter: 15,
    endChapter: 15,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.mark.testament"),
    id: "mark-start-15",
  },
  {
    name: "luke",
    bookAbbreviation: i18n.t("messages.bibleBooks.luke.abbreviation"),
    startChapter: 23,
    endChapter: 23,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.luke.testament"),
    id: "luke-start-23",
  },
  {
    name: "john",
    bookAbbreviation: i18n.t("messages.bibleBooks.john.abbreviation"),
    startChapter: 18,
    endChapter: 19,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.john.testament"),
    id: "john-start-18",
  },
  {
    name: "matthew",
    bookAbbreviation: i18n.t("messages.bibleBooks.matthew.abbreviation"),
    startChapter: 28,
    endChapter: 28,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.matthew.testament"),
    id: "matthew-start-28",
  },
  {
    name: "mark",
    bookAbbreviation: i18n.t("messages.bibleBooks.mark.abbreviation"),
    startChapter: 16,
    endChapter: 16,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.mark.testament"),
    id: "mark-start-16",
  },
  {
    name: "luke",
    bookAbbreviation: i18n.t("messages.bibleBooks.luke.abbreviation"),
    startChapter: 24,
    endChapter: 24,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.luke.testament"),
    id: "luke-start-24",
  },
  {
    name: "john",
    bookAbbreviation: i18n.t("messages.bibleBooks.john.abbreviation"),
    startChapter: 20,
    endChapter: 21,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.john.testament"),
    id: "john-start-20",
  },
  {
    name: "acts",
    bookAbbreviation: i18n.t("messages.bibleBooks.acts.abbreviation"),
    startChapter: 1,
    endChapter: 14,
    chapters: 14,
    testment: i18n.t("messages.bibleBooks.acts.testament"),
    id: "acts-start-1",
  },
  {
    name: "james",
    bookAbbreviation: i18n.t("messages.bibleBooks.james.abbreviation"),
    startChapter: 1,
    endChapter: 5,
    chapters: 5,
    testment: i18n.t("messages.bibleBooks.james.testament"),
    id: "james-start-1",
  },
  {
    name: "acts",
    bookAbbreviation: i18n.t("messages.bibleBooks.acts.abbreviation"),
    startChapter: 15,
    endChapter: 16,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.acts.testament"),
    id: "acts-start-15",
  },
  {
    name: "galatians",
    bookAbbreviation: i18n.t("messages.bibleBooks.galatians.abbreviation"),
    startChapter: 1,
    endChapter: 6,
    chapters: 6,
    testment: i18n.t("messages.bibleBooks.galatians.testament"),
    id: "galatians-start-1",
  },
  {
    name: "acts",
    bookAbbreviation: i18n.t("messages.bibleBooks.acts.abbreviation"),
    startChapter: 17,
    endChapter: 17,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.acts.testament"),
    id: "acts-start-17",
  },
  {
    name: "thessalonians1",
    bookAbbreviation: i18n.t("messages.bibleBooks.thessalonians1.abbreviation"),
    startChapter: 1,
    endChapter: 5,
    chapters: 5,
    testment: i18n.t("messages.bibleBooks.thessalonians1.testament"),
    id: "1thessalonians-start-1",
  },
  {
    name: "thessalonians2",
    bookAbbreviation: i18n.t("messages.bibleBooks.thessalonians2.abbreviation"),
    startChapter: 1,
    endChapter: 3,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.thessalonians2.testament"),
    id: "2thessalonians-start-1",
  },
  {
    name: "acts",
    bookAbbreviation: i18n.t("messages.bibleBooks.acts.abbreviation"),
    startChapter: 18,
    endChapter: 19,
    chapters: 2,
    testment: i18n.t("messages.bibleBooks.acts.testament"),
    id: "acts-start-18",
  },
  {
    name: "corinthians1",
    bookAbbreviation: i18n.t("messages.bibleBooks.corinthians1.abbreviation"),
    startChapter: 1,
    endChapter: 16,
    chapters: 16,
    testment: i18n.t("messages.bibleBooks.corinthians1.testament"),
    id: "1corinthians-start-1",
  },
  {
    name: "corinthians2",
    bookAbbreviation: i18n.t("messages.bibleBooks.corinthians2.abbreviation"),
    startChapter: 1,
    endChapter: 13,
    chapters: 13,
    testment: i18n.t("messages.bibleBooks.corinthians2.testament"),
    id: "2corinthians-start-1",
  },
  {
    name: "romans",
    bookAbbreviation: i18n.t("messages.bibleBooks.romans.abbreviation"),
    startChapter: 1,
    endChapter: 16,
    chapters: 16,
    testment: i18n.t("messages.bibleBooks.romans.testament"),
    id: "romans-start-1",
  },
  {
    name: "acts",
    bookAbbreviation: i18n.t("messages.bibleBooks.acts.abbreviation"),
    startChapter: 20,
    endChapter: 28,
    chapters: 9,
    testment: i18n.t("messages.bibleBooks.acts.testament"),
    id: "acts-start-20",
  },
  {
    name: "colossians",
    bookAbbreviation: i18n.t("messages.bibleBooks.colossians.abbreviation"),
    startChapter: 1,
    endChapter: 4,
    chapters: 4,
    testment: i18n.t("messages.bibleBooks.colossians.testament"),
    id: "colossians-start-1",
  },
  {
    name: "philemon",
    bookAbbreviation: i18n.t("messages.bibleBooks.philemon.abbreviation"),
    startChapter: 1,
    endChapter: 1,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.philemon.testament"),
    id: "philemon-start-1",
  },
  {
    name: "ephesians",
    bookAbbreviation: i18n.t("messages.bibleBooks.ephesians.abbreviation"),
    startChapter: 1,
    endChapter: 6,
    chapters: 6,
    testment: i18n.t("messages.bibleBooks.ephesians.testament"),
    id: "ephesians-start-1",
  },
  {
    name: "philippians",
    bookAbbreviation: i18n.t("messages.bibleBooks.philippians.abbreviation"),
    startChapter: 1,
    endChapter: 4,
    chapters: 4,
    testment: i18n.t("messages.bibleBooks.philippians.testament"),
    id: "philippians-start-1",
  },
  {
    name: "timothy1",
    bookAbbreviation: i18n.t("messages.bibleBooks.timothy1.abbreviation"),
    startChapter: 1,
    endChapter: 6,
    chapters: 6,
    testment: i18n.t("messages.bibleBooks.timothy1.testament"),
    id: "1timothy-start-1",
  },
  {
    name: "titus",
    bookAbbreviation: i18n.t("messages.bibleBooks.titus.abbreviation"),
    startChapter: 1,
    endChapter: 3,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.titus.testament"),
    id: "titus-start-1",
  },
  {
    name: "peter1",
    bookAbbreviation: i18n.t("messages.bibleBooks.peter1.abbreviation"),
    startChapter: 1,
    endChapter: 5,
    chapters: 5,
    testment: i18n.t("messages.bibleBooks.peter1.testament"),
    id: "1peter-start-1",
  },
  {
    name: "hebrews",
    bookAbbreviation: i18n.t("messages.bibleBooks.hebrews.abbreviation"),
    startChapter: 1,
    endChapter: 13,
    chapters: 13,
    testment: i18n.t("messages.bibleBooks.hebrews.testament"),
    id: "hebrews-start-1",
  },
  {
    name: "timothy2",
    bookAbbreviation: i18n.t("messages.bibleBooks.timothy2.abbreviation"),
    startChapter: 1,
    endChapter: 4,
    chapters: 4,
    testment: i18n.t("messages.bibleBooks.timothy2.testament"),
    id: "2timothy-start-1",
  },
  {
    name: "peter2",
    bookAbbreviation: i18n.t("messages.bibleBooks.peter2.abbreviation"),
    startChapter: 1,
    endChapter: 3,
    chapters: 3,
    testment: i18n.t("messages.bibleBooks.peter2.testament"),
    id: "2peter-start-1",
  },
  {
    name: "jude",
    bookAbbreviation: i18n.t("messages.bibleBooks.jude.abbreviation"),
    startChapter: 1,
    endChapter: 1,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.jude.testament"),
    id: "jude-start-1",
  },
  {
    name: "john1",
    bookAbbreviation: i18n.t("messages.bibleBooks.john1.abbreviation"),
    startChapter: 1,
    endChapter: 5,
    chapters: 5,
    testment: i18n.t("messages.bibleBooks.john1.testament"),
    id: "1john-start-1",
  },
  {
    name: "john2",
    bookAbbreviation: i18n.t("messages.bibleBooks.john2.abbreviation"),
    startChapter: 1,
    endChapter: 1,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.john2.testament"),
    id: "2john-start-1",
  },
  {
    name: "john3",
    bookAbbreviation: i18n.t("messages.bibleBooks.john3.abbreviation"),
    startChapter: 1,
    endChapter: 1,
    chapters: 1,
    testment: i18n.t("messages.bibleBooks.john3.testament"),
    id: "3john-start-1",
  },
  {
    name: "revelation",
    bookAbbreviation: i18n.t("messages.bibleBooks.revelation.abbreviation"),
    startChapter: 1,
    endChapter: 22,
    chapters: 22,
    testment: i18n.t("messages.bibleBooks.revelation.testament"),
    id: "revelation-start-1",
  },
];
